import type { FlattenSimpleInterpolation } from 'styled-components/macro';
import styled, { css } from 'styled-components/macro';

type FlexStyledT = {
  align?: 'start' | 'end' | 'center' | 'stretch';
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  justify?: 'center' | 'between' | 'around' | 'start' | 'end' | 'flex-start' | 'flex-end';
  gap?: string;
};

const start = css`
  align-items: flex-start;
`;

const end = css`
  align-items: flex-end;
`;

const center = css`
  align-items: center;
`;

const stretch = css`
  align-items: stretch;
`;

const justifyCenter = css`
  justify-content: center;
`;

const justifyStart = css`
  justify-content: start;
`;

const justifyFlexStart = css`
  justify-content: flex-start;
`;

const justifyEnd = css`
  justify-content: end;
`;

const justifyFlexEnd = css`
  justify-content: flex-end;
`;

const between = css`
  justify-content: space-between;
`;

const around = css`
  justify-content: space-around;
`;

const row = css`
  flex-direction: row;
`;

const rowReverse = css`
  flex-direction: row-reverse;
`;

const column = css`
  flex-direction: column;
`;

const columnReverse = css`
  flex-direction: column-reverse;
`;

const alignItems = {
  start,
  end,
  center,
  stretch,
};

const flexDirection = {
  row,
  'row-reverse': rowReverse,
  column,
  'column-reverse': columnReverse,
};

const justifyContent = {
  between,
  around,
  start: justifyStart,
  center: justifyCenter,
  end: justifyEnd,
  'flex-start': justifyFlexStart,
  'flex-end': justifyFlexEnd,
};

export const FlexContainerStyled = styled.div<FlexStyledT>`
  display: flex;
  ${({ align = 'center' }): FlattenSimpleInterpolation | string => (align ? alignItems[align] : '')}
  ${({ justify = 'between' }): FlattenSimpleInterpolation | string =>
    justify ? justifyContent[justify] : ''}
  ${({ direction = 'row' }): FlattenSimpleInterpolation | string =>
    direction ? flexDirection[direction] : ''}
  gap: ${({ gap }): string => gap ?? ''}
`;
